module.exports = __webpack_public_path__ + "static/media/appstore.2185b3f2.svg";